export default __webpack_public_path__ + "static/media/3.65ba5497.svg";